import { useSuspenseQueries } from '@tanstack/react-query'

import { dexfSettingsQueryOptions, translationsQueryOptions } from '@/query-options'

import { useLocale } from './use-locale'

export function useSettingsAndTranslations() {
  const { locale } = useLocale()

  const [{ data: translations }, { data: dexfSettings }] = useSuspenseQueries({
    queries: [translationsQueryOptions(locale), dexfSettingsQueryOptions(locale)],
  })

  return { dexfSettings, translations }
}
